"use strict";

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/gifts-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      & > svg {\n        width: 8px;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 14px;\n    & > svg {\n      width: 16px;\n      color: #1A203D !important;\n    }\n\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_select_1 = require("react-select");

var styled_components_1 = __importStar(require("styled-components"));

var ChevronDownSolid_1 = __importDefault(require("../../IconsNavigation/ChevronDownSolid"));

var Wrapper = styled_components_1["default"](react_select_1.components.DropdownIndicator)(_templateObject(), function (_ref) {
  var selectProps = _ref.selectProps;
  return styled_components_1.css(_templateObject2(), selectProps.size === "small" && styled_components_1.css(_templateObject3()));
});

var DropdownIndicator = function DropdownIndicator(_a) {
  var selectProps = _a.selectProps,
      rest = __rest(_a, ["selectProps"]);

  if (selectProps.hideDropdownIndicator) return null;
  return react_1["default"].createElement(Wrapper, Object.assign({
    selectProps: selectProps
  }, rest), react_1["default"].createElement(ChevronDownSolid_1["default"], null));
};

exports["default"] = DropdownIndicator;